import {BehaviorSubject} from "rxjs";
import {AssetUploadResponse} from "./upload.model";
import {EventEmitter} from "@angular/core";
import {UploadService} from "./upload.service";

/**
 * instantiate, hook up observers, start upload
 */
export class UploadProcess {

    $result: EventEmitter<AssetUploadResponse> = new EventEmitter();
    $progress: BehaviorSubject<number> = new BehaviorSubject(0);

    private current: AssetUploadResponse | null = null;
    private state: 'init' | 'uploading' | 'processing' | 'error' | 'finished';

    private readonly totalChunks: number;
    private chunks: Blob[];
    private chunkIndex: number = 0;

    constructor(private uploadService: UploadService, private file: File, chunkSize: number = 1024 * 1024) { // 1MB default
        this.chunks = chunk(file, chunkSize);
        this.totalChunks = this.chunks.length;
        this.state = 'init';
    }

    start() {
        if (this.state !== 'init') {
            throw new Error('Upload process already started');
        }
        this.state = 'uploading';
        this.uploadService.startUpload(this.file).subscribe({
            next: (response) => {
                this.current = response;
                this.uploadChunk();
            },
            error: (e) => {
                this.$result.error(e);
                console.error(e);
            }
        })
    }

    get id() {
        return this.current?.uuid
    }

    private uploadChunk() {
        if (this.state !== 'uploading') {
            throw new Error('Upload process not in uploading state');
        }

        if (this.chunkIndex >= this.totalChunks) {
            this.state = 'processing';
            // initial delay to give the server time to process the last chunk
            setTimeout(() => {
                this.pollStatus();
            }, 1000);
            return;
        }

       // console.log(this.id, 'uploading chunk ' + this.chunkIndex);
        this.uploadService.uploadChunk(this.id!, this.chunks[this.chunkIndex], this.chunkIndex).subscribe({
            next: (response) => {
                this.current = response;
                this.chunkIndex++;
                this.$progress.next(this.chunkIndex / this.totalChunks * 100);
                this.uploadChunk();
            },
            error: (e) => {
                this.$result.error(e);
                console.error(e);
            }
        });
    }

    private pollStatus() {
       // console.log(this.id, 'polling status');
        this.uploadService.getUploadStatus(this.id!).subscribe({
            next: (response) => {
                if (response.isComplete) {
                    this.current = response;
                    this.state = 'finished';
                    this.$result.emit(response);
                } else {
                    setTimeout(() => {
                        this.pollStatus();
                    }, 5000);
                }
            },
            error: (e) => {
                this.state = 'error';
                this.$result.error(e);
                console.error(e);
            }
        });
    }
}

function chunk(file: File, chunkSize: number): Blob[] {
    const chunks: Blob[] = [];
    let offset = 0;
    while (offset < file.size) {
        const chunk = file.slice(offset, offset + chunkSize);
        chunks.push(chunk);
        offset += chunkSize;
    }
    return chunks;
}
